<template>
    <div class="content-box" v-loading="mixinLoading">
        <template v-if="isPageAllowed">
            <div class="tab-bar ">
                <el-tabs v-model="activeTabName">
                    <el-tab-pane 
                        v-for="item in tabList"
                        :key="item.name"
                        :label="item.label" 
                        :name="item.name"
                    />
                </el-tabs>
            </div>
            <div class="content" v-if="!mixinLoading">
                <component  :is="activeTabName" :pageFuncNames="pageFuncNames" />
            </div>
        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>页面无权限描述</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>

<script>
    import { mapState,mapGetters } from 'vuex';
    import {pageMixin} from '../../mixins/pageMixin';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import ListPage from './page/listPage.vue'
    export default {
        name: "AppManagementPage",
        mixins: [pageMixin],
        components:{
            NoPermissionInfo,
            ListPage
        },
        data(){
            return {
               activeTabName: 'listPage'
            }
        },
        computed:{
            ...mapState({
                sidebarOpened:state => state.app.sidebar.opened,
            }),
            tabList() {
                const types = {
                    app_entry_page: {
                        label: '产品录入',
                        name: 'listPage'
                    }
                }
                return this.pageActionNames.map(v=> {
                    return types[v]
                })
            }
        },
        watch: {
            tabList(n) {
                if (n.length) {
                    this.activeTabName = n[0].name
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.tab-bar {
    background-color: #fff;
    padding: 0 0 0 30px;
    margin: -10px -10px 0;
    &::v-deep {
        .el-tabs__header {
            margin-bottom: 1px;
        }
    }
}
.content {
    margin-top: 10px;
}
.content-box {
    margin: 0 -10px;
}
</style>
